module.exports = __webpack_public_path__ + "static/media/icon-question-card-kebab.ec9a682c.svg";